var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',{staticClass:"no-activity-container"},[_c('b-col',{attrs:{"sm":"12"}},[_c('h3',[_vm._v(_vm._s(_vm.title))])]),_vm._v(" "),_c('b-col',{attrs:{"sm":"12"}},[_c('p',[_vm._v(_vm._s(_vm.body))])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1f3db67c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NoLicenseActivity.vue
// module id = 7k9m
// module chunks = 1